import {useCallback, useEffect, useRef, useState} from "react";

// Tracks only the action the reader started. The app-wide loader flag cannot do
// this job on these screens: it is set by any request in flight, so a
// background fetch on page load would spin the Submit button before the reader
// has touched anything.
export default function useBusy() {
  const [busy, setBusy] = useState(false);
  const mounted = useRef(true);

  useEffect(() => () => {
    mounted.current = false;
  }, []);

  const run = useCallback(async action => {
    setBusy(true);
    try {
      return await action();
    } finally {
      if (mounted.current) setBusy(false);
    }
  }, []);

  return [busy, run];
}
